import { Typography,Box, Button, CardMedia } from '@mui/material'
import React, { useEffect, useState } from 'react'
import principal from "../image/principal.jpg";
import { Prueba } from './Prueba';
import whitepaper from '../image/whitepaper.png'
import discord from '../image/discord.png'
import telegran from '../image/telegram.png'
import Modal from '@mui/material/Modal';
import { Registrar } from './Modales/Registrar';
import { rutas } from '../rutas/rutas';
import { getCookie } from '../utils/getCookies';
import { setInformacion } from '../store/slices/usuarios';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { CityFarmV2 } from '../version2/CityFarmV2';
import { CITYFARM_VERSION_FLAGS } from '../version2/versionFlags';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {xs: "95%", md: 450},
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,

};

const getRequestedVersion = () => {
  const hash = String(window.location.hash || '').toLowerCase();

  if (hash === '#/v2' && CITYFARM_VERSION_FLAGS.v2Enabled) return 'v2';
  if (!CITYFARM_VERSION_FLAGS.classicEnabled && CITYFARM_VERSION_FLAGS.v2Enabled) return 'v2';
  if (CITYFARM_VERSION_FLAGS.defaultVersion === 'v2' && CITYFARM_VERSION_FLAGS.v2Enabled) return 'v2';

  return 'classic';
};

export const Inicio = () => {
   const [pagina, setPagina] = useState(0)
   const [version, setVersion] = useState(getRequestedVersion)
   const [login, setLogin] = useState(false)
   const [open, setOpen] = useState(false);
   const dispatch = useDispatch()

   useEffect(() => {
     const syncVersionFromHash = () => setVersion(getRequestedVersion());
     window.addEventListener('hashchange', syncVersionFromHash);
     return () => window.removeEventListener('hashchange', syncVersionFromHash);
   }, []);

   const openV2 = () => {
     if (!CITYFARM_VERSION_FLAGS.v2Enabled) return;
     window.location.hash = '/v2';
     setVersion('v2');
   };

   const openClassic = () => {
     if (!CITYFARM_VERSION_FLAGS.classicEnabled) return;
     if (window.location.hash) {
       window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
     }
     setVersion('classic');
   };

   useEffect(()=>{  
     

    const tokenJWT = getCookie('token')
    if(tokenJWT){



      axios.get(`${rutas.getUsuario}`, { headers: {'token': tokenJWT}})
      .then(({data})=> {
    
        dispatch(setInformacion(data))
        setPagina(3)
      })
      .catch(err=>{
        console.log(err)
          setPagina(0)
      })
      
    }

  },[])
   const handleOpen = (id) => {
     setPagina(id)
     setOpen(true);
   }
   const handleClose = () => setOpen(false);
 
   const cambio = (registro)=>{
    setLogin(registro)
    setOpen(true);
    setPagina(1)

    // setTimeout(() => {
    //   setPagina(2)

    // }, 1000);
   }
  return (
 
       <Box
       className="rpgui-content"
       sx={{
        overflow: 'auto',
         width: "100%",
         height: "100vh",
       }}
     >
      <Box sx={{ 
            
                 width: "100%",
         height: "100vh",    display: "flex",
         justifyContent: "center",
         alignItems: "start",
    
         overflow: 'hidden'}} className="rpgui-container framed">

       {(pagina === 0 || pagina === 1 )&&<Box
       className={`rpgui-container framed ${pagina === 2 ? 'magictime swashOut' : ''}`}
         sx={{
           width: "80%",
           height: "65%",
           backgroundImage: `url(${principal}) !important` ,     
           backgroundSize: 'contain !important',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'space-around',
           flexDirection: 'column'
         }}
       >
        
       

        <Typography sx={{fontFamily: 'Minecraft', color: 'white', fontSize: '3rem !important'}}>
    City Farm
</Typography>

<Button onClick={()=>cambio(false)} class="rpgui-button" type="button"  ><p>log in</p></Button>
<Button onClick={()=>cambio(true)} class="rpgui-button" type="button"  ><p>signup</p></Button>
       </Box>}

      {pagina === 3 && version === 'classic' && <Prueba />}

      {pagina === 3 && version === 'v2' && (
        <CityFarmV2
          onBack={openClassic}
          classicEnabled={CITYFARM_VERSION_FLAGS.classicEnabled}
        />
      )}

      {pagina === 3 && version === 'classic' && CITYFARM_VERSION_FLAGS.v2Enabled && (
        <Button
          onClick={openV2}
          type="button"
          sx={{
            position: 'fixed',
            top: { xs: 10, sm: 14 },
            left: { xs: 10, sm: 14 },
            zIndex: 99999,
            minHeight: 46,
            px: { xs: 1.5, sm: 2.2 },
            py: 1,
            borderRadius: 2,
            border: '2px solid #ffd54a',
            color: '#fff',
            bgcolor: 'rgba(18, 25, 18, 0.92)',
            fontFamily: 'Minecraft',
            fontSize: { xs: '0.72rem', sm: '0.88rem' },
            lineHeight: 1.15,
            textTransform: 'none',
            boxShadow: '0 0 0 2px rgba(0,0,0,.45), 0 5px 16px rgba(0,0,0,.45)',
            '&:hover': {
              bgcolor: 'rgba(38, 70, 38, 0.97)',
              borderColor: '#fff176',
            },
          }}
        >
          🚀 Nueva versión BETA
        </Button>
      )}
     { pagina !==3 &&  <Box sx={{position: "fixed", bottom: 100, display: "flex"}}>
      <a target='_blank' href='https://mundo-virtual.gitbook.io/whitepaper1/'>
      <CardMedia
              className="rpgui-cursor-grab-open"
             component="img"
             image={whitepaper}
             sx={{ width: "80px", objectFit: "cover", m: '0 auto' }}
           />
             </a>
     
           <a target='_blank' href='https://discord.gg/WdSDtH8GZg'>
           <CardMedia 
     
              className="rpgui-cursor-grab-open"
             component="img"
             image={discord}
             sx={{ width: "80px", objectFit: "cover", m: '0 auto' }}
           />
           </a>


       
        
      </Box>}
     </Box>
  {  pagina !==3 && <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="rpgui-content"
      >
        <Box     className={`rpgui-container framed `} sx={style}>

        {pagina === 1&& <Registrar login={login} setPagina={setPagina} />}
        </Box>
      </Modal>}
     
     </Box>
  )
}

//magictime swashOut